import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

export const AdfHeading = React.memo(({ node }: AdfNodeProps) => {
    const level = node.attrs?.level || 1;
    const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

    return <HeadingTag>{node.content?.map((x, i) => <AdfNode key={i} node={x} />)}</HeadingTag>;
});
